import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 2,
  class: "time-out-flag"
}
const _hoisted_3 = {
  key: 3,
  class: "new-list-flag"
}
const _hoisted_4 = {
  key: 4,
  class: "black-list-flag"
}
const _hoisted_5 = { key: 3 }

import { reactive, computed, onMounted, ref } from 'vue'
import { potentialList, potentialDel, potentialDetail } from '@/api/gucangSales/customerCenter'
import dataConfig, { favoriteStatus } from '@/views/gucangSales/commonEnum/dataConfig'
import relationCode from '../components/relationCode/index.vue'
import addCodeModel from '@/views/gucangSales/customerCenter/accountCode/editModal.vue'
import sendLinkModel from '../components/sendLinkModel.vue'
import transferModel from '../components/transferModel.vue'
import ExportDetails from '@/views/gucangSales/clueManage/salesClue/components/ExportDetails.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { addToFav, cancelToFav, listByParamCodes } from '@/api/common'
import DCModal from '@/hooks/modalType'
import CosMergeButton from '@/components/CosMergeButton'

import type { PotentialItem } from '@/typings/api/customerCenter'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'

const __default__ = { name: 'DcCosFbuContract' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()
const tableRef = ref()
const sendLinkModelRef = ref()
const addCodeModelRef = ref()
const relationCodeRef = ref()
const transferModelRef = ref()
const selectedRows = ref<PotentialItem[]>([])

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

const queryForm = reactive({
  sortCollection: 1,
  dataPermissionType: undefined,
  contact: {
    type: 1
  },
  stage: 3 // 2 潜在 3签约 4成交
})
const paramCodeData = reactive<{
  fbu_sales_category: []
  fbu_product_type: []
  fbu_warehouse: []
  fbu_sale_platform: []
  fbu_service_demand: []
  fbu_demand_info: []
  fbu_erp_info: []
  fbu_replenish_frequency: []
  fbu_business_type: []
  fbu_marketing_activity: []
  fbu_customer_size: []
  fbu_industrial_belt: []
  fbu_customer_category: []
}>({
  fbu_sales_category: [], // 销售品类
  fbu_product_type: [], // 货物类型
  fbu_warehouse: [], // 合作海外仓
  fbu_sale_platform: [], // 在售电商平台
  fbu_service_demand: [], // 服务需求
  fbu_demand_info: [], // 需求海外仓
  fbu_erp_info: [], // 目前使用ERP
  fbu_replenish_frequency: [], // 头程补货频次
  fbu_business_type: [], // 客户业务类型
  fbu_marketing_activity: [], // 关联市场活动
  fbu_customer_size: [], // 客户规模
  fbu_industrial_belt: [], // 产业带
  fbu_customer_category: [] // 客户类别
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_sales_category',
      'fbu_product_type',
      'fbu_warehouse',
      'fbu_sale_platform',
      'fbu_service_demand',
      'fbu_demand_info',
      'fbu_erp_info',
      'fbu_replenish_frequency',
      'fbu_business_type',
      'fbu_marketing_activity',
      'fbu_customer_size',
      'fbu_industrial_belt',
      'fbu_customer_category'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  potentialList({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
// 获取掩码信息
const showMask = (record: PotentialItem, callBack: (res: any) => void) => {
  potentialDetail(record.cosId).then((res) => {
    callBack(res.data.contact)
  })
}
const search = () => {
  tableRef.value.search()
}
const onSelectChange = (selectedRowKeys: string[], rows: PotentialItem[]) => {
  selectedRows.value = rows
}
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle(selectedRows.value)
}
// 删除
const handleDelete = (row: PotentialItem) => {
  DCModal.delete({
    content: `删除【${row.customerName}】，会同步删除该客户相关的商机、访客计划、跟进记录，且删除操作无法恢复，请谨慎操作。`,
    onOk() {
      potentialDel({ cosIdList: [row.cosId] }).then(() => {
        message.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
// 关联客户代码
const handleRelationCode = (row: PotentialItem) => {
  relationCodeRef.value.toggle(row)
}
// 新增关联代码
const handleAddCode = (row: PotentialItem) => {
  addCodeModelRef.value.toggle({
    cosId: row.cosId
  })
}
// 编辑
const handleEdit = (row: PotentialItem) => {
  router.push({
    path: '/fbu/contract/edit',
    query: {
      cosId: row.cosId
    }
  })
}
// 写跟进
const handleFollowUp = (row: PotentialItem) => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: {
      followRefId: row.cosId,
      returnPath: route.fullPath
    }
  })
}
// 写商机
const handleAddBuss = (row: PotentialItem) => {
  router.push({
    path: '/fbu/business/add',
    query: {
      saleChanceRefId: row.cosId
    }
  })
}
// 新增访客计划
const hanleAddVisitor = (row: PotentialItem) => {
  router.push({
    path: '/fbu/visitorProgram/add',
    query: {
      saleChanceRefId: row.cosId
    }
  })
}
// 转成交
const handleToDeal = (row: PotentialItem) => {
  router.push({
    path: '/fbu/turnToDeal',
    query: {
      cosId: row.cosId
    }
  })
}
// 发送注册链接
const handleSendLink = (row: PotentialItem) => {
  sendLinkModelRef.value.toggle(row)
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 收藏
const addFavorite = (row: PotentialItem, index:number) => {
  addToFav({
    appId: 'cos_fbu',
    cosId: row.cosId,
    stage: 3
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = row.cosId
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 收藏
const cancelFavorite = (row: PotentialItem, index:number) => {
  cancelToFav({
    appId: 'cos_fbu',
    cosId: row.cosId,
    stage: 3
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = null
      row.collectionTime = null
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 流失激活
const activation = (row: PotentialItem) => {
  router.push({
    path: '/fbu/customerActive',
    query: {
      cosId: row.cosId,
      type: 'contract'
    }
  })
}

const statusEnum = dataConfig.contractStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))

const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  { title: '主客户代码', dataIndex: 'customerNumber' },
  { title: '来源渠道', dataIndex: 'channel', width: 150 },
  { title: '签约客户状态', dataIndex: 'status' },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '剩余跟进天数', dataIndex: 'remanentFollowDays' },
  { title: '未跟进天数', dataIndex: 'unfollowDays' },
  {
    title: '最新跟进情况',
    dataIndex: 'followDesc'
  },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '联系人姓名', dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: '手机号', dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: '微信号', dataIndex: ['contact', 'wechat'], cosType: 'mask' },
  { title: '邮箱', dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: 'QQ号', dataIndex: ['contact', 'qq'], cosType: 'mask' },
  { title: '固定电话', dataIndex: ['contact', 'tel'], cosType: 'mask' },
  { title: '传真号', dataIndex: ['contact', 'fax'] },
  { title: '性别', dataIndex: ['contact', 'sex'], dicData: dataConfig.genderEnum },
  { title: '角色', dataIndex: ['contact', 'jobRole'], dicData: dataConfig.linkRoleTypeEnum },
  { title: '部门职务', dataIndex: ['contact', 'jobDuty'] },
  { title: '转签约时间', dataIndex: 'turnedContract', width: 190 },
  { title: '客户类型', dataIndex: 'type', dicData: dataConfig.customerTypeEnum },
  { title: '工厂详细地址', dataIndex: 'factoryAddress' },
  { title: '公司详细地址', dataIndex: 'customerAddress' },
  { title: '客户规模', dataIndex: 'enterpriseScale', dicData: paramCodeData.fbu_customer_size },
  { title: '业务类型', dataIndex: ['business', 'businessType'], dicData: paramCodeData.fbu_business_type },
  { title: '年销售GMV(万)', dataIndex: ['business', 'annualSales'], width: 140 },
  { title: '销售品类', dataIndex: ['business', 'salesCategory'], dicData: paramCodeData.fbu_sales_category },
  { title: '是否供货商', dataIndex: ['business', 'supplierFlag'], dicData: dataConfig.flagEnum },
  { title: '是否分销商', dataIndex: ['business', 'dealerFlag'], dicData: dataConfig.flagEnum },
  { title: '需要金融产品', dataIndex: ['business', 'financialProductFlag'], dicData: dataConfig.flagEnum },
  { title: '合作海外仓', dataIndex: ['business', 'warehouse'], dicData: paramCodeData.fbu_warehouse },
  { title: '货物类型', dataIndex: ['business', 'cargoType'], dicData: paramCodeData.fbu_product_type },
  { title: '是否产业带', dataIndex: ['business', 'industrialBeltFlag'], dicData: dataConfig.flagEnum },
  { title: '产业带', dataIndex: ['business', 'industrialBelt'], dicData: paramCodeData.fbu_industrial_belt },
  { title: '产业带名称', dataIndex: ['business', 'industrialBeltName'] },
  { title: '客户类别', dataIndex: ['business', 'customerCategory'], dicData: paramCodeData.fbu_customer_category },
  {
    title: '备注',
    dataIndex: 'customerRemark'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 245,
    fixed: 'right'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: queryForm.dataPermissionType,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.dataPermissionType) = $event)),
            onChange: search
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: undefined,
                tab: "全部"
              })),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 1,
                tab: "我的客户",
                "force-render": ""
              })),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 2,
                tab: "下属的客户"
              }))
            ]),
            _: 1
          }, 8, ["activeKey"]),
          _createVNode(_component_cos_table, {
            rowKey: "cosId",
            "row-selection": { onChange: onSelectChange },
            serials: "",
            columns: columns.value,
            tableId: "fbuContrat",
            onFetch: fetch,
            onMask: showMask,
            search: queryForm,
            "onUpdate:search": _cache[19] || (_cache[19] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "签约客户状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.status,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.status) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        mode: "multiple",
                        options: _unref(dataConfig).contractStatusEnum
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "剩余跟进天数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.remanentFollowDayType,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.remanentFollowDayType) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).remanentFollowDayTypeEnum
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "转签约时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.turnedContractStart,
                        "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.turnedContractStart) = $event)),
                        endTime: queryForm.turnedContractEnd,
                        "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.turnedContractEnd) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "子客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.arkCode,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.arkCode) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "联系方式" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.contact.type,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.contact.type) = $event)),
                            style: {"width":"33%"},
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("手机号")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 3 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("邮箱")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 4 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("微信号")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 5 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("qq")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("固定电话")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_a_input, {
                            value: queryForm.contact.keyword,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                            style: {"width":"67%"},
                            placeholder: "请输入"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: queryForm.seller,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.seller) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "领取时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.receiveStart,
                        "onUpdate:startTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.receiveStart) = $event)),
                        endTime: queryForm.receiveEnd,
                        "onUpdate:endTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.receiveEnd) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.cosId,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.cosId) = $event)),
                        maxlength: 500,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "排序" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.sortCollection,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.sortCollection) = $event)),
                        options: _unref(dataConfig).favoriteStatus,
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "未跟进天数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.unfollowDayType,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.unfollowDayType) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).customerUnfollowDayTypeEnum
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "来源渠道" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(ParamCodeCascader, {
                            type: "search",
                            ids: queryForm.channelList,
                            "onUpdate:ids": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.channelList) = $event)),
                            appId: "cos_fbu",
                            paramCode: "fbu_source_channel",
                            style: {"width":"33%"}
                          }, null, 8, ["ids"]),
                          _createVNode(_component_a_input, {
                            value: queryForm.channelExplain,
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.channelExplain) = $event)),
                            maxlength: 100,
                            style: {"width":"67%"},
                            placeholder: "请输入",
                            allowClear: ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record, text,index }) => [
              (column.dataIndex === 'customerName')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (record.collectionId===null)
                      ? (_openBlock(), _createBlock(FavoriteIcon, {
                          key: 0,
                          type: "add",
                          onClick: ($event: any) => (addFavorite(record,index))
                        }, null, 8, ["onClick"]))
                      : (_openBlock(), _createBlock(FavoriteIcon, {
                          key: 1,
                          type: "cancel",
                          onClick: ($event: any) => (cancelFavorite(record,index))
                        }, null, 8, ["onClick"])),
                    (record.timeoutFlag === true)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "超时"))
                      : _createCommentVNode("", true),
                    (record.haveFollowFlag === false)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "New"))
                      : _createCommentVNode("", true),
                    (record.blackListFlag)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "黑名单"))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: `/fbu/contract/view?cosId=${record.cosId}`,
                      class: "ant-table-cell-ellipsis",
                      title: text
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(text || '--'), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "title"])
                  ]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'channel')
                ? (_openBlock(), _createBlock(ChannelText, {
                    key: 1,
                    appId: "cos_fbu",
                    paramCode: "fbu_source_channel",
                    value: text,
                    desc: record.channelExplain
                  }, null, 8, ["value", "desc"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerRegion')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 2,
                    appId: "cos_fbu",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'arkCode')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(Array.isArray(text) && text.length > 0 ? text.join('、') : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 4,
                    enums: _unref(statusEnum),
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 5 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleSendLink(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("发送注册链接")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_contract_send_link_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleToDeal(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("转成交")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_contract_deal_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleFollowUp(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("写跟进")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, !record.blackListFlag],
                        [_directive_permission, 'fbu_contract_follow_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (hanleAddVisitor(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增访客计划")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_contract_visitori_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                        type: "link",
                        workCode: record.seller,
                        onClick: ($event: any) => (handleAddBuss(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增商机")
                        ]),
                        _: 2
                      }, 1032, ["workCode", "onClick"])), [
                        [_directive_permission, 'fbu_contract_buss_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleAddCode(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增客户代码")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, !record.blackListFlag],
                        [_directive_permission, 'fbu_contract_code_add_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleRelationCode(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("关联客户代码")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, !record.blackListFlag],
                        [_directive_permission, 'fbu_contract_code_relative_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (activation(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("流失激活")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_vShow, record.status === 22 || record.status === 36],
                        [_directive_permission, 'fbu_contract_loss_active_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_contract_edit_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleDelete(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_contract_del_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (handleTransfer()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("转移客户")
                ]),
                _: 1
              })), [
                [_directive_permission, 'fbu_contract_transfer_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(CosMergeButton), {
                data: selectedRows.value,
                appId: "cos_fbu",
                fbuType: 3,
                onSuccess: success
              }, {
                default: _withCtx(() => [
                  _createTextVNode("合并")
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_permission, 'fbu_contract_customer_aggregation_merge_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_fbu",
                taskType: "204",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'fbu_contract_export_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (handleExportDetails()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出明细")
                ]),
                _: 1
              })), [
                [_directive_permission, 'fbu_contract_export_details_btn']
              ])
            ]),
            _: 1
          }, 8, ["row-selection", "columns", "search"]),
          _createVNode(sendLinkModel, {
            ref_key: "sendLinkModelRef",
            ref: sendLinkModelRef
          }, null, 512),
          _createVNode(addCodeModel, {
            ref_key: "addCodeModelRef",
            ref: addCodeModelRef,
            onSuccess: success
          }, null, 512),
          _createVNode(relationCode, {
            ref_key: "relationCodeRef",
            ref: relationCodeRef,
            onSuccess: success
          }, null, 512),
          _createVNode(transferModel, {
            ref_key: "transferModelRef",
            ref: transferModelRef,
            onSuccess: success
          }, null, 512),
          _createVNode(ExportDetails, {
            ref_key: "exportDetailsRef",
            ref: exportDetailsRef,
            appId: "cos_fbu",
            search: queryForm,
            taskTypeEnum: [
  { value: 216, label: '签到地址' },
  { value: 220, label: '在售平台' },
  { value: 224, label: '需求海外仓' }
]
          }, null, 8, ["search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})